// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getDoc } from 'firebase/firestore';
import { userDoc } from '../utils/firestoreRefs';  // NEW: centralised ref helper

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);   // Firebase Auth user
  const [userData, setUserData]   = useState(null);       // Firestore /users/{uid}
  const [loading,   setLoading]   = useState(true);

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      if (user?.uid) {
        try {
          const userRef = userDoc(user.uid);      // 🔑 UID-keyed doc
          const snap    = await getDoc(userRef);
          setUserData(snap.exists() ? snap.data() : null);
        } catch (err) {
          console.error('Error fetching user doc by uid:', err);
          setUserData(null);
        }
      } else {
        setUserData(null); // signed out
      }

      setLoading(false);
    });

    return unsubscribe; // clean-up
  }, []);

  const value = { currentUser, userData };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
